<template>
  <div class="flex flex-col justify-center h-full">
    <h1 class="mb-6 text-6xl font-bold text-center">
      404
    </h1>

    <div class="mb-6 font-bold text-center">
      Страница не найдена
    </div>

    <div class="text-center">
      <router-link
        to="/"
        class="inline-block py-2 px-3 font-bold text-white bg-teal-400 rounded"
      >
        Вернуться на главную
      </router-link>
    </div>
  </div>
</template>

<script setup lang="ts">

</script>

<style scoped>

</style>
